module.exports = __webpack_public_path__ + "img/16d001-08.10b9c759.jpg";